module.exports = __webpack_public_path__ + "static/img/chassis.81df113.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xiangyun/chassis.png
// module id = Y9Xb
// module chunks = 1